import React from 'react';
import { StarIcon } from 'lucide-react';
import { heroReviews } from '../data/megapack';
function Stars() {
  return <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-223" data-mp="3fc9hce9nuqf9">
      {[0, 1, 2, 3, 4].map(star => <StarIcon key={star} className="h-3.5 w-3.5 fill-gold-400 text-gold-400" aria-hidden="true" data-id="element-224" data-mp="30ndagkjcbjg8" />)}
    </div>;
}
export function SocialProofStrip() {
  return <section className="w-full bg-forest-50 px-5 py-10" aria-label="Opiniones de seños" data-id="element-225" data-mp="35l52dejzj5kf">
      <ul className="mx-auto grid max-w-5xl gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-226" data-mp="2rpt4iyaj8yza">
        {heroReviews.map(review => <li key={review.name} className="flex flex-col rounded-2xl border-2 border-forest-100 bg-white p-5 shadow-card" data-id="element-227" data-mp="2wkgpwoa8pd9n">
            <Stars data-id="element-228" data-mp="2mo3vtpas8xed" />
            <blockquote className="mt-3 flex-1 text-[13px] leading-relaxed text-forest-900/80" data-id="element-229" data-mp="2mpoof9dje69l">
              “{review.quote}”
            </blockquote>
            <figcaption className="mt-4 flex items-center gap-2.5" data-id="element-230" data-mp="fwcpw25msfts">
              <span className="flex h-8 w-8 flex-none items-center justify-center rounded-full bg-forest-800 text-[11px] font-extrabold text-cream" data-id="element-231" data-mp="kwqtn80793m0">
                {review.initials}
              </span>
              <span data-id="element-232" data-mp="2q6sklkw3f8j3">
                <span className="block font-display text-xs font-bold text-forest-800" data-id="element-233" data-mp="2q57xuhg0stvs">
                  {review.name}
                </span>
                <span className="block text-[11px] text-forest-900/55" data-id="element-234" data-mp="2zxwy0g64elbt">{review.role}</span>
              </span>
            </figcaption>
          </li>)}
      </ul>
    </section>;
}